var _style, _defs, _g, _defs2, _path, _path2, _path3, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUserbyCostCenter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000096050763344600990350000005912276778628393609_);}\r\n\t.st1{fill:#0069BF;}\r\n\t.st2{fill:none;stroke:#0081EA;}\r\n\t.st3{clip-path:url(#SVGID_00000097489818369408117110000015488407912894538163_);}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st6{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:1.3;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.7,
    y: -0.7,
    width: 25.4,
    height: 25.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049938061117611370500000006577185743829638078_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Create_User",
    style: {
      clipPath: "url(#SVGID_00000049938061117611370500000006577185743829638078_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_255",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 11,
    cy: 11,
    r: 11.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 11,
    cy: 11,
    r: 11.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15659",
    transform: "translate(7.981 7.25)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000029754236870924334850000008578351104848536488_",
    x: 30.9,
    y: -2.6,
    width: 8.5,
    height: 10.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039830420287167966260000003469439560473055388_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029754236870924334850000008578351104848536488_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15605",
    style: {
      clipPath: "url(#SVGID_00000039830420287167966260000003469439560473055388_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32501",
    className: "st4",
    d: "M32.1,7.4c-0.2,0-0.3-0.1-0.4-0.1c-0.5-0.2-0.8-0.8-0.8-1.4c0-0.6,0.2-1.2,0.4-1.7 c0.4-0.9,1.2-1.7,2.1-2.1L33.6,2c-0.8-0.6-1.2-1.6-1-2.6c0.1-0.6,0.4-1.1,0.9-1.5c1-0.8,2.5-0.7,3.5,0.2c0.5,0.5,0.8,1.3,0.7,2 c-0.1,0.7-0.4,1.4-1,1.9c0.1,0.1,0.3,0.1,0.4,0.2c1,0.5,1.8,1.4,2.1,2.5c0.2,0.5,0.2,1,0.2,1.4c0,0.7-0.5,1.2-1.2,1.3 c0,0,0,0-0.1,0L32.1,7.4z M35.1,6.7c0.9,0,1.9,0,2.8,0c0.4,0,0.7-0.2,0.7-0.6c0,0,0-0.1,0-0.1c0-0.2,0-0.3,0-0.5 c-0.1-0.6-0.4-1.2-0.8-1.7c-0.5-0.6-1.3-1.1-2.1-1.2c-0.7-0.1-1.3,0-1.9,0.3c-0.7,0.3-1.3,0.8-1.6,1.5 c-0.3,0.5-0.4,1.1-0.4,1.7c0,0.1,0.1,0.3,0.1,0.4c0.1,0.2,0.4,0.3,0.6,0.2L35.1,6.7 M35.1-1.9c-1,0-1.8,0.8-1.8,1.8 c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C36.9-1.1,36.1-1.9,35.1-1.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32502",
    className: "st5",
    d: "M35.1,6.7h-2.8c-0.2,0-0.4-0.1-0.6-0.2c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.6,0.1-1.2,0.4-1.7 c0.4-0.7,0.9-1.2,1.6-1.5c1.4-0.6,3.1-0.3,4.1,0.9c0.4,0.5,0.7,1.1,0.8,1.7c0,0.2,0,0.3,0,0.5c0,0.4-0.2,0.7-0.6,0.7 c0,0-0.1,0-0.1,0C37,6.7,36.1,6.7,35.1,6.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32503",
    className: "st5",
    d: "M35.1-1.9c1,0,1.8,0.8,1.8,1.8c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8 C33.3-1,34.1-1.9,35.1-1.9"
  }))))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 12,
    cy: 12,
    r: 7.1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 12,
    y1: 8.8,
    x2: 12,
    y2: 15.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 15.2,
    y1: 12.1,
    x2: 8.7,
    y2: 12.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserbyCostCenter);
export default __webpack_public_path__ + "static/media/AddUserbyCostCenter.ec99f1d273f1271a2a4bcf9d0e03b6e5.svg";
export { ForwardRef as ReactComponent };